import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { AnalyticsBlockContainer } from 'shared/components/analytics_block/container';
import { NewbuildingPremiumBuilderInfo } from 'shared/containers/AuthorAsideContainerNew/parts';
import { AsideBuyAnalyticsBlockContainer } from 'shared/containers/BuyAnalyticsBlocks';
import {
  selectBestPlaceAnalyticsAvailable,
  selectIsBestPlaceAnalyticsEnabled,
} from 'shared/selectors/bestPlaceAnalytics';
import { selectBuyAnalyticsReportAvailability } from 'shared/selectors/buyAnalyticsModal';
import { isCommercialSelector } from 'shared/selectors/offerData/offer/isCommercialSelector';

import { PriceContainer } from './Price';
import { PriceChangesContainer } from './PriceChanges';
import { AsideGroup } from '../../components/AsideSection/AsideGroup';
import { AsideItem } from '../../components/AsideSection/AsideItem';
import { AsideSection } from '../../components/AsideSection/AsideSection';
import { DealRent } from '../../components/DealRent';
import { PriceAuction } from '../../components/PriceAuction/PriceAuction';
import { OfferCardAsideContainer } from '../../components/aside/container';
import { AsideBannersContainer } from '../../components/aside_banners/container';
import { isDealRent as isDealRentSelector } from '../../selectors/isDealRent';
import { selectIsMortgageBannerEnabled } from '../../selectors/mortgage/selectIsMortgageBannerEnabled';
import { selectIsNewbuildingPremiumRate } from '../../selectors/newbuildingPremiumRate';
import { selectIsMortgageBannerAvailable } from '../../selectors/offerData/selectIsMortgageBannerAvailable';
import { selectIsAuctionBankObject } from '../../selectors/selectIsAuctionBankObject';
import { AsideMortgageBannerContainer } from '../Adfox/AsideMortgageBannerContainer';
import { useApplicationContext } from '../ApplicationContext';
import { AsideContactsContainer } from '../AsideContacts/AsideContacts';
import { AuthorAsideContainer as AuthorAsideContainerNew } from '../AuthorAsideContainerNew';
import { MortgageSidebarBannerContainer } from '../MortgageSidebarBannerContainer';
import { MortgageWidgetContainer } from '../MortgageWidgetRedesignContainer';
import { NewbuildingBuildersFactsContainer } from '../NewbuildingBuildersFactsContainer';
import { OfferFactsInSidebarContainer } from '../OfferFactsInSidebarContainer';
import { PriceRelevance } from '../PriceRelevance';
import { RentBlockContainer } from '../RentBlockContainer';
import { AgencyBrandingAsideCardContainer } from '../agencyBranding/AgencyBrandingAsideCard';

export const AsideRedesignedContainer = () => {
  const { logger } = useApplicationContext();
  const isDealRent = useSelector(isDealRentSelector);

  const isAuctionBankObject = useSelector(selectIsAuctionBankObject);
  const isCommercial = useSelector(isCommercialSelector);
  const isPremiumNewbuilding = useSelector(selectIsNewbuildingPremiumRate);
  const isMortgageEnabled = useSelector(selectIsMortgageBannerEnabled);
  const isBannerVisible = useSelector(selectIsMortgageBannerAvailable);
  const isBuyAnalyticsButtonEnabled = useSelector(selectBuyAnalyticsReportAvailability);
  const isBestPlaceAnalyticsEnabled = useSelector(selectIsBestPlaceAnalyticsEnabled);
  const isBestPlaceAnalyticsAvailable = useSelector(selectBestPlaceAnalyticsAvailable);
  const isBestPlaceAnalyticsDisplayed = isBestPlaceAnalyticsEnabled && isBestPlaceAnalyticsAvailable;
  const isCreSpaceAnalyticsDisplayed = !isBestPlaceAnalyticsDisplayed && isBuyAnalyticsButtonEnabled;

  return (
    <OfferCardAsideContainer>
      <AsideSection dataName="AsideMainInfo">
        <AsideGroup>
          <AsideItem>
            <PriceRelevance />
          </AsideItem>
          <AsideItem>{isAuctionBankObject && <PriceAuction />}</AsideItem>
          <AsideItem>
            <PriceContainer />
          </AsideItem>
          <AsideItem>
            <PriceChangesContainer />
          </AsideItem>
        </AsideGroup>
        <AsideGroup>
          <AsideItem>{isMortgageEnabled && <MortgageWidgetContainer />}</AsideItem>
        </AsideGroup>
        <AsideGroup>
          <AsideItem>
            <OfferFactsInSidebarContainer />
          </AsideItem>
        </AsideGroup>
        <AsideContactsContainer />
      </AsideSection>
      {isCreSpaceAnalyticsDisplayed && (
        <AsideSection>
          <AnalyticsBlockContainer />
        </AsideSection>
      )}

      <AsideSection dataName="AuthorAside">
        <AuthorAsideContainerNew />
      </AsideSection>
      {isCreSpaceAnalyticsDisplayed && (
        <AsideSection>
          <AsideBuyAnalyticsBlockContainer />
        </AsideSection>
      )}
      <AsideSection dataName="AuthorBrandingAside" withShadow={false} withBorders={false} withSpaces={false}>
        <NewbuildingPremiumBuilderInfo />
        <AgencyBrandingAsideCardContainer />
      </AsideSection>

      {isBannerVisible && (
        <AsideSection
          dataName="AsideBanner"
          hideForPrint={true}
          withShadow={false}
          withBorders={false}
          withSpaces={false}
        >
          <AsideMortgageBannerContainer />
        </AsideSection>
      )}
      <DealRent />
      {isDealRent && <RentBlockContainer />}
      <NewbuildingBuildersFactsContainer />

      {!isPremiumNewbuilding && (
        <AsideSection dataName="AsideAd" hideForPrint={true} withShadow={false} withBorders={false} withSpaces={false}>
          <ErrorLogComponent logger={logger}>
            <AsideBannersContainer />
          </ErrorLogComponent>
        </AsideSection>
      )}
      {!isPremiumNewbuilding && !isCommercial && (
        <AsideSection dataName="AsideMortgageBanner" hideForPrint={true} withShadow={false}>
          <MortgageSidebarBannerContainer />
        </AsideSection>
      )}
    </OfferCardAsideContainer>
  );
};
